import { useEffect } from 'react';
import useSegmentation from 'hooks/user/useSegmentation';
import { cookieConsentId } from './shared/constants';
import { createScript } from './shared/helpers';

export default function CookieConsentLoader() {
    const { culture } = useSegmentation();
    const languageCode = culture.split('-')[0].toUpperCase();

    useEffect(() => {
        if (!document || !document.body) return;
        if (document.getElementById(cookieConsentId)) return; // prevent double inject

        document.body.appendChild(createScript(languageCode));
    }, [languageCode]);

    return null;
}
